exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hzlistholder{display:inline;margin-right:20px}.labelAlignTop{display:inline-block;text-align:center}", ""]);

// exports
